export enum navTypeEnums {
  PROJECT = "project",
  /** Registrations confirmed but not yet attached to a session (date choice). */
  TO_PLAN = "to_plan",
  COMING = "coming",
  IN_PROGRESS = "in_progress",
  ALL = "all",
  FINISHED = "finished",
  HABILITATION = "habilitation",
  TRAINING = "training",
  LEARNING_PATH = "learning_path",
  CANCELED = "canceled",
}

/** Two steps of the "Ajouter une session" modal opened from Gestion du catalogue. */
export enum AddSessionTabEnum {
  GENERAL = "general",
  STEPS = "steps",
}

export const AddSessionTabLabel: Record<AddSessionTabEnum, string> = {
  [AddSessionTabEnum.GENERAL]: "Informations générales",
  [AddSessionTabEnum.STEPS]: "Étapes",
};

/** Which pending timeslot edit the "modifications non enregistrées" dialog is guarding. */
export enum TimeslotConfirmModeEnum {
  CREATE = "create",
  EDIT = "edit",
  ADD_SESSION = "addSession",
}

/** Column keys from the orders `default_headers` seed; custom-field columns add their own. */
export enum SessionAttendeesColumnEnum {
  ALERTS = "alerts",
  LASTNAME = "lastname",
  EMAIL = "email",
  LEGAL_ENTITY = "legalEntity",
  JOB = "job",
  TEAM = "team",
  SITE = "site",
  STATUS = "status",
  ICS_STATUS = "icsStatus",
  COMPLETION_RATE = "completionRate",
  ATTENDED_HOURS = "attendedHours",
  SCORE = "score",
  SUMMONED_AT = "summonedAt",
  START_DATE = "startDate",
  END_DATE = "endDate",
  MANAGER = "manager",
  MANAGER_2 = "manager2",
  CONTRACT_START_DATE = "contractStartDate",
}
